import { Component, Input, Output } from '@angular/core';
import { PlatformService } from '@panamax/app-state';

import { FoodCostReportState, FoodCostTarget } from '@usf/ngrx-inventory';
import { FoodCostCalculatorService } from '../../services/food-cost-calculator.service';
@Component({
  selector: 'app-food-cost-report-details',
  templateUrl: './food-cost-report-details.component.html',
  styleUrls: ['./food-cost-report-details.component.scss'],
})
export class FoodCostReportDetailsComponent {
  @Input() foodCostReport: FoodCostReportState;

  constructor(
    readonly platformService: PlatformService,
    readonly foodCostCalculatorService: FoodCostCalculatorService,
  ) {}

  dismissModal() {
    this.foodCostCalculatorService.showHideFoodCostReportDetailsModal(false);
  }

  onDidDismiss() {
    this.dismissModal();
  }
}
